import { render, staticRenderFns } from "./TenantPreferenceForm.vue?vue&type=template&id=1aa66ee8&"
import script from "./TenantPreferenceForm.vue?vue&type=script&lang=ts&"
export * from "./TenantPreferenceForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports